/// <amd-module name="SuiteCommerce.GridOrder"/>
define("SuiteCommerce.GridOrder", ["require", "exports", "SuiteCommerce.GridOrder.Item.Controller", "SuiteCommerce.GridOrder.Item.Model", "SuiteCommerce.GridOrder.Model", "SuiteCommerce.GridOrder.View"], function (require, exports, GridOrder_Item_Controller_1, Item_Model_1, GridOrder_Model_1, GridOrder_View_1) {
    "use strict";
    return {
        visualComponent: null,
        mountInVisualComponent: function (component, container) {
            var _this = this;
            this.visualComponent = component;
            this.visualComponent.addChildView('Product.Sku', function () {
                var itemController = new GridOrder_Item_Controller_1.GridOrderItemController({
                    item: new Item_Model_1.ItemModel(_this.visualComponent.getItemInfo().item),
                });
                if (!itemController.itemIsValidMatrix()) {
                    return;
                }
                var columnMatrixOption = itemController.getColumnOption();
                var rowMatrixOption = itemController.getRowOption();
                // Clear any matrix child item selection
                _this.clearSelectedMatrixChildOptions(columnMatrixOption, rowMatrixOption);
                var gridOrderModel = new GridOrder_Model_1.GridOrderModel({
                    columnMatrixOption: columnMatrixOption,
                    rowMatrixOption: rowMatrixOption,
                    headers: itemController.getHeadersFromItem(),
                    rows: itemController.getRowsFromItem(),
                });
                var gridOrderView = new GridOrder_View_1.GridOrderView({
                    container: container,
                    model: gridOrderModel,
                });
                return gridOrderView;
            });
        },
        clearSelectedMatrixChildOptions: function (column, row) {
            if (column) {
                this.visualComponent.setOption(column.internalid, null);
            }
            if (row) {
                this.visualComponent.setOption(row.internalid, null);
            }
        },
    };
});
